export const OR_REGISTRATION_BETA_FEATURES = [
  'OR_REGISTRATION_RAVEN',
];

export const OR_MANAGEMENT_BETA_FEATURES = [
  'OR_MANAGEMENT_RAVEN',
];
